class HeroSlideshow extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-hero-track]');
    this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
    this.prevBtn = this.querySelector('[data-hero-prev]');
    this.nextBtn = this.querySelector('[data-hero-next]');
    this.index = 0;
    this.count = this.slides.length;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = (parseInt(this.dataset.speed, 10) || 6) * 1000;
    this.timer = null;
    this.touchStartX = null;
  }

  connectedCallback() {
    if (!this.track || this.count <= 1) return;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

    this.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
    this.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.maybeStart());

    // Theme editor: jump to the slide whose block is selected
    document.addEventListener('shopify:block:select', (event) => {
      const slide = this.slides.findIndex((s) => s.dataset.blockId === event.detail.blockId);
      if (slide !== -1) {
        this.go(slide);
        this.stop();
      }
    });
    document.addEventListener('shopify:block:deselect', () => this.maybeStart());

    this.update();
    this.maybeStart();
  }

  disconnectedCallback() {
    this.stop();
  }

  go(target) {
    this.index = (target + this.count) % this.count;
    this.update();
    if (this.autoplay) {
      this.stop();
      this.maybeStart();
    }
  }

  update() {
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
    this.slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.index);
      dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
    });
  }

  maybeStart() {
    if (!this.autoplay || this.count <= 1) return;
    this.timer = setInterval(() => this.go(this.index + 1), this.speed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  onTouchStart(event) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event) {
    if (this.touchStartX === null) return;
    const delta = event.changedTouches[0].screenX - this.touchStartX;
    if (Math.abs(delta) > 40) {
      this.go(delta < 0 ? this.index + 1 : this.index - 1);
    }
    this.touchStartX = null;
  }
}

if (!customElements.get('hero-slideshow')) {
  customElements.define('hero-slideshow', HeroSlideshow);
}

/* Open a Klaviyo onsite form when a [data-klaviyo-open] trigger is clicked */
if (!window.__heroKlaviyoBound) {
  window.__heroKlaviyoBound = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-klaviyo-open]');
    if (!trigger) return;
    const formId = trigger.getAttribute('data-klaviyo-open');
    if (!formId) return;
    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
}
